<script setup lang="ts">
const { fetchUserProfile } = useUserData();

function submit() {
  fetchUserProfile();
}
</script>

<template>
  <div :class="$style.boxContainer">
    <img
      alt="Email icon"
      aria-hidden="true"
      :class="$style.modalIcon"
      :src="getAssetsUrlForCDN('/assets/images/svg/loading.svg')"
    />

    <p :class="$style.title">
      {{ $t('verification.loading.title') }}
    </p>

    <p
      :class="$style.description"
      v-html="$t('verification.loading.desc')"
    />

    <button
      :class="[$style.submitBtn, 'btn-primary']"
      @click="submit()"
    >
      {{ $t('verification.loading.refresh') }}
      <NuxtIcon name="arrows/angle_right" />
    </button>
  </div>
</template>

<style module lang="scss">
.boxContainer {
  @apply p-3 md:p-6 flex flex-col justify-center flex-1 text-texts text-center;

  .modalIcon {
    @apply w-28 h-28 mx-auto mb-5;
  }

  .title {
    @apply font-bold mb-3;
  }

  .description {
    @apply mb-1 max-w-80 inline-block mx-auto text-sm text-texts/80;

    strong {
      @apply text-primary/80;
    }
  }

  .submitBtn {
    @apply mx-auto rounded-md gap-1.5 flex items-center font-bold uppercase py-2.5 focus:outline-none focus:ring-4 mt-6;
  }
}
</style>
